import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { update_user, get_all_users,  } from "../../redux/actions/userAction";
import { toast } from 'react-toastify';

const EditUser = ({ closeModal, userData, role, search, page }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  if (!userData) return null;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: userData
  });

  // Admin accounts should not allow role/status edits
  const isAdmin = userData?.role === "admin";

  /**  Reset when selected user changes */
  useEffect(() => {
    reset(userData);
  }, [userData, reset]);


  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        first_name: data.first_name,
        last_name: data.last_name,
        mobile_no: data.mobile_no,
        // role: data.role,
        // status: data.status === "true" || data.status === true,
        street_no: data.street_no,
        street_name: data.street_name,
        province: data.province,
        postal_code: data.postal_code,
        role: isAdmin ? userData.role : data.role,
        status: isAdmin
          ? userData.status
          : data.status === "true" || data.status === true,
        city: data.city,
        address: data.address,
        unit: data.unit
      };

      const res = await dispatch(
        update_user({
          uuid: userData.uuid,
          payload
        })
      );

      if (res.meta.requestStatus === "fulfilled") {
        toast.success('User updated successfully!');
        closeModal();
        dispatch(get_all_users({ page: page, limit: 10, role, search }));
      } else {
        toast.error(res.payload?.message || 'Failed to update user!');
      }
    } catch (error) {
      toast.error(error?.message || 'An error occurred while updating user!');
      console.error('Error updating user:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modal show d-block" style={{ zIndex: "9999" }} role="dialog" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content" style={{ marginTop: '40px' }}>

            {/* HEADER */}
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                Edit User – {userData.first_name}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={closeModal}
              />
            </div>

            {/* BODY */}
            <div className="modal-body" style={{ maxHeight: '63vh', overflowY: 'auto' }}>
              <form id="edit-user-form" onSubmit={handleSubmit(onSubmit)}>
                <div className="row g-3">

                  {/* FIRST NAME */}
                  <div className="col-md-6">
                    <label className="form-label">First Name</label>
                    <input
                      className="form-control"
                      {...register("first_name", { required: true })}
                    />
                    {errors.first_name && (
                      <small className="text-danger">
                        First name is required
                      </small>
                    )}
                  </div>

                  {/* LAST NAME */}
                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input
                      className="form-control"
                      {...register("last_name")}
                    />
                  </div>

                  {/* EMAIL (READ ONLY) */}
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      className="form-control"
                      disabled
                      {...register("email")}
                    />
                  </div>

                  {/* MOBILE */}
                  <div className="col-md-6">
                    <label className="form-label">Mobile</label>
                    <input
                      className="form-control"
                      {...register("mobile_no")}
                    />
                  </div>

                  {/* ROLE */}
                  <div className="col-md-6">
                    <label className="form-label">Role</label>
                    <input
                      className="form-control"
                      defaultValue={userData.role}
                      // readOnly
                      disabled
                      {...register("role")}
                    />
                  </div>

                  {/* STATUS */}
{/* <div className="col-md-6">
  <label className="form-label">Status</label>
  <select className="form-select" {...register("status")}>
    <option value={true}>Active</option>
    <option value={false}>Inactive</option>
  </select>
</div> */}
<div className="col-md-6">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      {...register("status")}
                      disabled={isAdmin}
                    >
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                  </div>
         {/* Street no */}
                  <div className="col-md-6">
                    <label className="form-label">Street no</label>
                    <input
                      className="form-control"
                      {...register("street_no")}
                    />
                  </div>

                    {/* Street name */}
                  <div className="col-md-6">
                    <label className="form-label">Street Name</label>
                    <input
                      className="form-control"
                      {...register("street_name")}
                    />
                  </div>

                    {/* CITY */}
                  <div className="col-md-6">
                    <label className="form-label">City</label>
                    <input
                      className="form-control"
                      {...register("city")}
                    />
                  </div>

                    {/* Province*/}
                  <div className="col-md-6">
                    <label className="form-label">Province</label>
                    <input
                      className="form-control"
                      {...register("province")}
                    />
                  </div>
                     {/* postal code*/}
                  <div className="col-md-6">
                    <label className="form-label">Postal Code</label>
                    <input
                      className="form-control"
                      {...register("postal_code")}
                    />
                  </div>

                       {/* unit*/}
                  <div className="col-md-6">
                    <label className="form-label">Unit / Suite</label>
                    <input
                      className="form-control"
                      {...register("unit")}
                    />
                </div>

                  {/* <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      {...register("status")}
                      disabled={isAdmin}
                    >
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                  </div> */}

                  {/* ADDRESS */}
                  <div className="col-md-6">
                    <label className="form-label">Address</label>
                    <input
                      className="form-control"
                      {...register("address")}
                    />
                  </div>
                

                </div>
              </form>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal} disabled={loading }>
                Cancel
              </button>
            
              <button
                type="submit"
                form="edit-user-form"
                className="btn btn-primary"
                disabled={loading }
              >
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
 
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default EditUser;
